import { render, staticRenderFns } from "./SpecialistCompare.vue?vue&type=template&id=fa73c9b6&scoped=true&"
import script from "./SpecialistCompare.vue?vue&type=script&lang=js&"
export * from "./SpecialistCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa73c9b6",
  null
  
)

export default component.exports